import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { resetState, rerenderTable } from './../../store/ingredientComponentTranslations.actions';

// components
import { ModalStepper } from 'dumb';
import IngredientComponentTranslationsModalStep from './components/ingredientComponentTranslationsModalStep';

// services
import { addIngredientComponentTranslations } from './../../ingredientComponentTranslations.service';

// phrases
import phrases from './../../ingredientComponentTranslations.phrases';

const IngredientComponentTranslationsModalBatch = ({ allergenId, onClose }) => {
	const modalRef = useRef();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const batchList = useSelector((store) => store.ingredientComponentTranslations.batchList);

	const onNext = () => {
		setLoading(true);

		const payload = batchList.map((entry) => ({
			ingredient_component: allergenId,
			name: entry.name,
			language: entry.language?.value?.id ?? null,
		}));

		addIngredientComponentTranslations({ batch: payload })
			.then(() => {
				setLoading(false);
				dispatch(rerenderTable());
				onClose();
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const steps = [
		{
			component: <IngredientComponentTranslationsModalStep />,
			title: phrases.MODAL_TITLE,
			onBack: onClose,
			onNext,
			loading,
			isValid: true,
			confirmButtonLabel: phrases.SUBMIT,
			defaultStyles: false,
			noScroll: false,
		},
	];

	useEffect(() => {
		return () => {
			dispatch(resetState());
		};
	}, [dispatch]);

	return (
		<ModalStepper header={phrases.MODAL_TITLE} onClose={onClose} ref={modalRef} isOpen steps={steps} showStep={false} />
	);
};

IngredientComponentTranslationsModalBatch.propTypes = {
	onClose: PropTypes.func,
	allergenId: PropTypes.number,
};

export default IngredientComponentTranslationsModalBatch;
